exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-e5aa0276]{width:780px;padding:50px 0 50px 30px;border-top:1px solid #000}", ""]);

// exports
